/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { updateCampaignNameRequestSchema } from '../campaign-schema';

export const updateCampaignNamePathSchema = z.object({
  campaignId: z.string(),
});

export const updateCampaignNameRequestBodySchema =
  updateCampaignNameRequestSchema;

export type UpdateCampaignNameInput = {
  path: z.input<typeof updateCampaignNamePathSchema>;
  body?: z.input<typeof updateCampaignNameRequestBodySchema>;
  signal?: AbortSignal;
};

export async function updateCampaignName({
  path,
  body,
  signal,
}: UpdateCampaignNameInput): Promise<void> {
  const parsedPath = updateCampaignNamePathSchema.parse(path);
  const parsedBody =
    body === undefined
      ? undefined
      : updateCampaignNameRequestBodySchema.parse(body);

  await socialApiClient.patch(`campaigns/${parsedPath.campaignId}/name`, {
    signal,
    ...(parsedBody === undefined ? {} : { json: parsedBody }),
  });
}
